"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EventBusSynchronizedCacheListener = void 0;
const core_1 = require("../../core");
const types_1 = require("./types");
const utils_1 = require("./utils");
class EventBusSynchronizedCacheListener {
    constructor(cacheName, cache, eventBus) {
        this.eventBus = eventBus;
        this.cacheName = cacheName;
        this.cache = cache;
    }
    initializeListeners() {
        this.eventBus.subscribe((0, utils_1.getEventName)(this.cacheName, types_1.TypeEventMap.SET.toString()), (event) => {
            core_1.Log.info(`[EventBusSynchronizedStoreInformant] ${this.cacheName}: Event SET received: ${JSON.stringify(event)}`);
            const data = event.getData();
            if (data) {
                this.cache.setCached(data.key, data.result, data.cacheLiveTime);
            }
        });
        this.eventBus.subscribe((0, utils_1.getEventName)(this.cacheName, types_1.TypeEventMap.REMOVE.toString()), (event) => {
            core_1.Log.info(`[EventBusSynchronizedStoreInformant] ${this.cacheName}: Event REMOVE received: ${JSON.stringify(event)}`);
            const data = event.getData();
            if (data) {
                this.cache.removeCached(data.key);
            }
        });
        this.eventBus.subscribe((0, utils_1.getEventName)(this.cacheName, types_1.TypeEventMap.CLEAR.toString()), (event) => {
            core_1.Log.info(`[EventBusSynchronizedStoreInformant] ${this.cacheName}: Event CLEAR received: ${JSON.stringify(event)}`);
            this.cache.cleanCache();
        });
    }
}
exports.EventBusSynchronizedCacheListener = EventBusSynchronizedCacheListener;
//# sourceMappingURL=listener.js.map